/*
 *
 * HeaderContainer reducer
 *
 */

import { fromJS } from 'immutable';
import {
  DEFAULT_ACTION,
  FETCH_USER_PROFILE_SUCCESS,
  SET_USER_CITY,
  DEFAULT_CITY,
  DEFAULT_ERROR,
  DEFAULT_ERROR_CLEAR,
  SET_SEARCH_TYPE,
  SET_USER_PROFILE_LOGOUT,
  SET_WINDOW_SCREENCHANGE,
  SET_EVOUCHER_OTP,
  // FETCH_USER_PROFILE_ERROR,
  // FETCH_USER_PROFILE,
} from './constants';

const initialState = fromJS({
  userDetails: {},
  loggedIn: false,
  selectedCity: DEFAULT_CITY,
  apiResonse: {},
  isLoading: false,
  search: {
    type: 'giftCards',
  },
  isMobileScreen: true,
  evocherOtp: {},
});

/**
 * @todo: making loading at the root level will not stop the component to render, rather it will show other component on UI
 */
function headerContainerReducer(state = initialState, action) {
  const { payload } = action;
  switch (action.type) {
    case DEFAULT_ACTION:
      return state
        .set('isLoading', payload);
    case DEFAULT_ERROR:
      return state
        .set('apiResonse', fromJS(payload))
        .set('isLoading', false);
    case DEFAULT_ERROR_CLEAR:
      return state
        .set('apiResonse', fromJS(payload || {}));
    // case FETCH_USER_PROFILE_ERROR: /** @desc moving function to DEFAULT_ACTION */
    //   return state
    //     .set('isLoading', false);
    case FETCH_USER_PROFILE_SUCCESS:
      return state
        .set('loggedIn', true)
        .set('userDetails', fromJS(action.payload))
        .set('evocherOtp', fromJS({}))
        .set('isLoading', false);
    case SET_USER_PROFILE_LOGOUT:
      return state
        .set('loggedIn', false)
        .set('userDetails', fromJS({}))
        .set('isLoading', false);
    case SET_USER_CITY:
      return state
        .set('selectedCity', fromJS(payload));
    case SET_SEARCH_TYPE:
      return state.set('search', fromJS(payload));
    case SET_WINDOW_SCREENCHANGE:
      return state.set('isMobileScreen', payload);
    case SET_EVOUCHER_OTP:
      return state
        .set('evocherOtp', fromJS(payload))
        .set('isLoading', false);
    default:
      return state;
  }
}

export default headerContainerReducer;



// WEBPACK FOOTER //
// client/containers/HeaderContainer/reducer.js